import { CollectionSelectOnTargetValue } from './collection-select-on-target-value';
import PromotionCoupon from './promotion-coupon';
CollectionSelectOnTargetValue.init();
PromotionCoupon.init();
